import { useGoogleMap } from '@react-google-maps/api';
import { useEffect, useState } from 'react';

export const DrawingMarker = ({
  lastMarker,
  setLastMarker,
  icon
}: {
  lastMarker: google.maps.Marker | null;
  setLastMarker: React.Dispatch<React.SetStateAction<google.maps.Marker | null>>;
  icon?: string;
}) => {
  const [drawingManager] = useState<google.maps.drawing.DrawingManager>(
    new google.maps.drawing.DrawingManager({
      drawingMode: google.maps.drawing.OverlayType.MARKER,
      drawingControl: true,
      drawingControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM,
        drawingModes: [google.maps.drawing.OverlayType.MARKER]
      }
    })
  );

  if (icon) {
    const size = 48;
    const half = size / 2;
    drawingManager.setOptions({
      markerOptions: {
        icon: {
          url: `/icons${icon}`,
          scaledSize: new google.maps.Size(size, size),
          anchor: new google.maps.Point(half, size)
        }
      }
    });
  }
  const map = useGoogleMap();
  drawingManager.setMap(map);
  const geocoder = new google.maps.Geocoder();

  const event = google.maps.event.addListener(drawingManager, 'markercomplete', (marker: google.maps.Marker) => {
    lastMarker?.setMap(null);

    geocoder.geocode({ location: marker.getPosition() }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        if (results && results[0]) {
          marker.setTitle(results[0].formatted_address);
          setLastMarker(marker);
        }
      } else {
        console.error('Geocoder failed due to: ' + status);
      }
    });
  });

  useEffect(() => {
    return () => google.maps.event.removeListener(event);
  }, []);

  return <></>;
};
